<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <sc-dialog-title>{{'station selection' | translate:['tmc.station-selection-dialog.title', translationService.language]}}</sc-dialog-title>
  <sc-separator-line></sc-separator-line>
  <sc-flex-fitting-content [vertical]="true">
    <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
      <div class="reasonSelector">
        <app-dictionary-key-select (selectionChanged)="optionsChanged($event)"
          [required]="configurationService.isRequired('ui-component.station-assignment-client.forward-transport-dialog.forwarding-cause.required', true)"
          placeholder="{{'forwarding cause' | translate: ['tmc.station-selection.forward-transport-dialog.cause-selection.title', translationService.language]}}"
          [rootKey]="'lookup.forwarding-cause.options'" [required]="false">
        </app-dictionary-key-select>
      </div>
      <sc-flex-fitting-content [vertical]="true">
        <app-structure-selection [context]="data"></app-structure-selection>
      </sc-flex-fitting-content>
    </sc-flex>
  </sc-flex-fitting-content>
  <sc-separator-line></sc-separator-line>
  <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button (click)="cancelDialog()">{{'cancel' | translate:['shared.selection-dialog.action.cancel',
          translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="confirmDialog()" [disabled]="!selectionValid">{{'confirm' |
          translate:['shared.selection-dialog.action.confirm',
          translationService.language]}}</button>
  </sc-actionbar>
</sc-flex>
